import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { clearActiveEvent } from '../actions/event'; 
import { EmptyTableMsg } from './EmptyTableMsg'
import  PlusIcon  from './icons/PlusIcon';

// This is basic flex table component. It allows you to render a flex table fairly easily. 
// It is dependent on the pic-events-flextable.scss. It has fixed number of columns/cells. 
// It accepts a single prop, which is an array of rows, within each row it has an array of columns.
// The array must be pre-poulated with jsx before passing it into the rows prop. Each column in 
// the array can have either text or JSX. If a specific column or columns needs to have custom 
// styling it should be done from Parent class and saved in the table array as JSX. If you plan to 
// render different type of tables, you should make copy of this component and associated scss file 
// and customize them  for your application.
// Component takes two props"
//  1) rows - is an array of elements containing one array that represents columns in a row
//           the  outter array represents the rows in the table
//  2) emptymsg  - the message to display when table is empty.
class PicEventsTable extends React.Component {

    constructor(props) {
        super(props);
    }

    handleCreateEvent = () => {
        console.log(`Inside handleCreate Event`)
        console.log(`....dispatchingclearActiveEvent`)
        this.props.clearActiveEvent();
    };
  
    // This method takes an argument of array. Each element in the array is 
    // another array representing number of columns in a row. For each row 
    // it extracts a fixed number of columns (in this case 4). Each column
    // is pre-populated with either text, jsx. All 4 columns a mapped into
    // one larger JSX element representing a flex row is added to the resulting array.
    // The resultant array with JSX is returned once all rows are processed.

    renderEventRows = (rows) => {
        let jxs = [];

        let view = this.props.view  || 'default';

        if (view === 'default') {
            rows.forEach((row, i) => {
                let [col1, col2, col3, col4] = row;
                jxs.push(
                    <div className="events-flex-row" key={i}>
                        <div className="events-flex-cell-1">
                            {col1}
                        </div>
                        <div className="events-flex-cell-2">
                            {col2}
                        </div>
                        <div className="events-flex-cell-3">
                            {col3}
                        </div>
                        <div className="events-flex-cell-4 rc-flex-container-center rc-mt-pt5">
                            {col4}
                        </div>
                    </div>  
                )
            })
            return jxs;
        }

        if (view === 'alternateView1') {
            rows.forEach((row, i) => {
                let [col1, col2] = row;
                jxs.push(
                    <div className="events-flex-row" key={i}>
                        <div className="alt-view1-flex-cell-1 ">
                            {col1}
                        </div>
                        <div className="alt-view1-flex-cell-2 alt-view-style-cell-1">
                            {col2}
                        </div>
                    </div>  
                )
            })
            return jxs;
        }
    }

    render () {
        let rows = this.props.rows;
        return (
        <div>
            <div className="events-flex-table-container"> 
                <div className="events-flex-table">
                   {rows.length > 0 
                        ? this.renderEventRows(rows)
                        : (<EmptyTableMsg className="empty-table-msg"
                               emptymsg={this.props.emptymsg}
                           />)
                    }
                </div>
                <div className="events-plus-icon-container" style={{marginTop: 'rem', zIndex: '10'}}>
                    <Link to="/eventmanage/event" onClick={this.handleCreateEvent}>
                        <PlusIcon  />
                    </Link>     
                </div>
                
               
            </div>
        </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    clearActiveEvent: () => dispatch(clearActiveEvent()),
})

const mapStateToProps = (state) => {
    return {
        event:  state.event
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PicEventsTable);




// WEBPACK FOOTER //
// ./src/components/PicEventsTable.js